import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectDetailAnalyticIds = {
  detailTabId: string;
  matchingTabId: string;
  teamMembersTabId: string;
  ticketsTabId: string;
  approvalTabId: string;
};

export const useAscProjectDetailTabIds = (): AscProjectDetailAnalyticIds => ({
  detailTabId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DRAWER_DETAIL_TAB),
  matchingTabId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DRAWER_MATCHING_TAB),
  teamMembersTabId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DRAWER_CONTRIBUTOR_TAB),
  ticketsTabId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DRAWER_TICKETS_TAB),
  approvalTabId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DRAWER_APPROVAL_TAB),
});
